import { AuthProvider } from "@/context/auth/authProvider";
import { FidexaHubAuthProvider } from "@/context/fidexaHubAuth/fidexaHubAuthProvider";
import { Suspense } from "react";
import { Outlet, ScrollRestoration } from "react-router";
import { ToastContainer } from "react-toastify";

export const RootLayout = () => {
  return (
    <AuthProvider>
      <FidexaHubAuthProvider>
        {/* Telas da área logada chegam sob demanda (src/routes/lazyPages.ts).
            O site público está no bundle principal e não suspende aqui. */}
        <Suspense fallback={null}>
          <Outlet />
        </Suspense>
        <ScrollRestoration />
        <ToastContainer style={{ zIndex: 9999999 }} />
      </FidexaHubAuthProvider>
    </AuthProvider>
  );
};
